import TextField from '@mui/material/TextField'
import { styled } from '@mui/material/styles'

export const StyledTextField = styled(TextField)({
  'input-label': {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    color: 'red'
  },
  input: {
    color: 'white',
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: 'white'
    }
  },
  '& label.Mui-focused': {
    color: 'white'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'white'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'white',
      borderRadius: 30
    },
    '&:hover fieldset': {
      borderColor: 'white'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'white'
    }
  }
})

export default StyledTextField
